import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "inicio" }
const _hoisted_2 = { class: "row text-center adicon-hero items-center" }
const _hoisted_3 = { class: "col adicon-font-2 text-bold" }
const _hoisted_4 = { id: "servicios" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-10 col-md-12 col-sm-12 col-xs-12 q-mb-xl" }
const _hoisted_7 = {
  class: "service-tile text-center",
  style: {"width":"93%"}
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "text-body adicon-font-1 text-grey-7 q-mt-md" }
const _hoisted_10 = {
  class: "row",
  id: "nuestra-mision"
}
const _hoisted_11 = { class: "col-lg-6 col-md-6 q-py-xl bg-grey-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-7 q-pa-lg" }
const _hoisted_14 = {
  class: "bg-white q-pa-md q-mb-lg shadow-10",
  style: {"width":"70%"}
}
const _hoisted_15 = {
  class: "row",
  id: "quienes-somos"
}
const _hoisted_16 = { class: "col-lg-6 col-md-6 q-pa-xl who-are-we" }
const _hoisted_17 = {
  style: {"border":"solid 1px #fff"},
  class: "q-pa-lg"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-lg-7" }
const _hoisted_20 = {
  class: "q-py-xl",
  id: "clientes"
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-7 col-xs-12 col-md-12 col-sm-12" }
const _hoisted_23 = {
  class: "q-py-xl bg-grey-3",
  id: "directors"
}
const _hoisted_24 = { class: "row q-mb-lg" }
const _hoisted_25 = { class: "col-xs-4 col-sm-3 col-md-2 col-lg-1" }
const _hoisted_26 = {
  class: "q-py-xl",
  id: "contacto"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-7" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-6 col-xs-12 q-pa-md" }
const _hoisted_31 = { class: "col-lg-6 col-xs-12 q-pa-md" }
const _hoisted_32 = { class: "col-lg-12 col-xs-12 q-pa-md" }
const _hoisted_33 = { class: "col-lg-12 col-xs-12 q-pa-md q-mb-md" }
const _hoisted_34 = { class: "text-h6 text-center" }
const _hoisted_35 = {
  key: 0,
  class: "fas fa-check fa-2x text-green-7"
}
const _hoisted_36 = {
  key: 1,
  class: "fas fa-times fa-2x text-red-7"
}
const _hoisted_37 = {
  key: 0,
  class: "text-h6 text-bold adicon-font-2 text-center"
}
const _hoisted_38 = {
  key: 1,
  class: "text-h6 text-bold adicon-font-2 text-center"
}
const _hoisted_39 = { class: "row bg-cyan-8 q-py-xl" }
const _hoisted_40 = { class: "col-lg-7 q-pa-md" }
const _hoisted_41 = { class: "row q-mb-lg" }
const _hoisted_42 = { class: "col-lg-4 col-md-4 col-xs-12" }
const _hoisted_43 = {
  class: "q-mb-md",
  style: {"width":"50px","height":"50px","background-color":"white","border-radius":"25px","padding":"10px"}
}
const _hoisted_44 = { class: "col-lg-2 col-md-2 col-xs-6" }
const _hoisted_45 = {
  href: "#inicio",
  class: "adicon-font-1 text-white q-mb-sm",
  style: {"text-decoration":"none","display":"block"}
}
const _hoisted_46 = {
  href: "#servicios",
  class: "adicon-font-1 text-white q-mb-sm",
  style: {"text-decoration":"none","display":"block"}
}
const _hoisted_47 = {
  href: "#nuestra-mision",
  class: "adicon-font-1 text-white q-mb-sm",
  style: {"text-decoration":"none","display":"block"}
}
const _hoisted_48 = {
  href: "#clientes",
  class: "adicon-font-1 text-white q-mb-sm",
  style: {"text-decoration":"none","display":"block"}
}
const _hoisted_49 = {
  href: "#directors",
  class: "adicon-font-1 text-white q-mb-sm",
  style: {"text-decoration":"none","display":"block"}
}
const _hoisted_50 = {
  href: "#contacto",
  class: "adicon-font-1 text-white q-mb-sm",
  style: {"text-decoration":"none","display":"block"}
}
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "text-body2 adicon-font-1 text-white text-center full-width" }

import "vue3-carousel/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { ref } from "vue";

// REFS

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const formData = ref({
  name: "",
  telephone: "",
  email: "",
  content: "",
});
const contactFormDialog = ref(false);
const contactSuccess = ref(false);

// METHODS
const validateContactData = () => {
  if (
    formData.value.name.length > 0 ||
    formData.value.telephone.length >= 7 ||
    formData.value.email.match(validEmail) ||
    formData.value.content.length > 0
  ) {
    sendContactEmail();
    contactSuccess.value = true;
    formData.value = {
      name: "",
      telephone: "",
      email: "",
      content: "",
    };
  } else {
    contactSuccess.value = false;
  }
  contactFormDialog.value = true;
};

const sendContactEmail = () => {
  console.log("SENDING EMAIL");
};

// VALID EMAIL REGEX
const validEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// CAROUSEL CONFIG
const carouselConfig = {
  wrapAround: true,
  autoplay: 2000,
  breakpoints: {
    300: {
      itemsToShow: 2,
      snapAlign: "center",
    },
    400: {
      itemsToShow: 3,
      snapAlign: "center",
    },
    500: {
      itemsToShow: 5,
      snapAlign: "center",
    },
  },
};

// CAROUSEL CONFIG
const servicesCarouselConfig = {
  wrapAround: true,
  autoplay: 5000,
  breakpoints: {
    300: {
      itemsToShow: 1,
    },
    800: {
      itemsToShow: 2,
    },
    900: {
      itemsToShow: 3,
    },
    1300: {
      itemsToShow: 4,
    },
  },
};

// CAROUSEL IMGS
const clients = [
  "arenera_balboa.png",
  "bypass_cafe.png",
  "cerro_punta.png",
  "copanac_new.png",
  "flex.png",
  "furniture_city.png",
  "grupo_sigma.png",
  "hospital_nacional.png",
  "itesa.png",
  "kenneth_cole.png",
  "nisato.png",
  "plastifom.png",
  "riba_smith.png",
  "tecnilab.png",
];

const services = [
  {
    title: "Diseño y fortalecimiento de RRHH",
    icon: "user-check",
    description:
      "Creamos o reestructuramos departamentos de Recursos Humanos para que operen con autonomía y estrategia.",
  },
  {
    title: "Reingeniería y desarrollo organizacional",
    icon: "sync-alt",
    description:
      "Optimización de procesos, estructura y cultura para lograr eficiencia.",
  },
  {
    title: "Desarrollo de estructuras organizativas, puestos y KPI's.",
    icon: "chart-line",
    description:
      "Diseño de organigramas, descripciones de puesto y métricas de gestión.",
  },
  {
    title: "Headhunting<br />&nbsp;",
    icon: "search",
    description:
      "Búsqueda y selección estratégica de talento clave para tu organización.",
  },
  {
    title: "Estudios de clima<br />organizacional",
    icon: "feather-alt",
    description:
      "Analizamos el ambiente interno para impulsar acciones concretas de mejora y bienestar laboral.",
  },
  {
    title: "Desarrollo de sistemas de evaluación de personal",
    icon: "people-arrows",
    description:
      "Aplicamos herramientas de retroalimentación integral para potenciar el rendimiento y desarrollo del talento.",
  },
  {
    title: "Talleres de<br/>integración",
    icon: "hammer",
    description:
      "Diseñamos talleres prácticos que fortalecen habilidades blandas y cohesionan equipos de alto desempeño.",
  },
  {
    title: "Gestión del cambio y liderazgo",
    icon: "star",
    description:
      "Acompañamos procesos de transformación organizacional con enfoque humano y estratégico.",
  },
  {
    title: "Sistema de gestión de calidad",
    icon: "tasks",
    description:
      "Documentamos y optimizamos procesos clave para preparar a tu organización hacia la certificación y mejora continua.",
  },
  {
    title: "Coaching psicológico profesional",
    icon: "brain",
    description:
      "Sesiones individuales de acompañamiento para quienes buscan claridad, desarrollo personal y bienestar laboral.",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_page = _resolveComponent("q-page")!
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-h3 text-bold text-white q-mb-lg desktop-only" }, [
              _createTextVNode(" Desarrollando equipos "),
              _createElementVNode("br"),
              _createTextVNode("de alto rendimiento ")
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-h4 text-bold text-white q-mb-lg mobile-only" }, " Desarrollando equipos de alto rendimiento ", -1)),
            _withDirectives(_createVNode(_component_q_btn, {
              outline: "",
              color: "white",
              class: "text-bold q-px-md q-py-xs",
              label: "conócenos",
              href: "#nuestra-mision"
            }, null, 512), [
              [_directive_smooth_scroll]
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row q-py-xl" }, [
          _createElementVNode("div", { class: "col desktop-only" }),
          _createElementVNode("div", { class: "col-lg-10 col-md-12 q-pa-md" }, [
            _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col" }, [
                _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold text-center q-mb-sm" }, " Nuestros Servicios ")
              ])
            ])
          ]),
          _createElementVNode("div", { class: "col desktop-only" })
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Carousel), _mergeProps(servicesCarouselConfig, { style: {"padding":"0 40px 40px 40px"} }), {
              addons: _withCtx(() => [
                _createVNode(_unref(Navigation)),
                _createVNode(_unref(Pagination))
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service, index) => {
                  return _createVNode(_unref(Slide), { key: index }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("i", {
                          class: _normalizeClass(`fas fa-${service.icon} fa-3x text-deep-orange-7 q-mb-lg`)
                        }, null, 2),
                        _createElementVNode("div", {
                          class: "text-h6 adicon-font-1 text-bold q-mb-sm",
                          innerHTML: service.title
                        }, null, 8, _hoisted_8),
                        _createVNode(_component_q_separator, {
                          color: "deep-orange-7",
                          style: {"width":"100px","margin":"0 auto","height":"2px"}
                        }),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(service.description), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            }, 16)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col" }, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col desktop-only" }, null, -1)),
            _createElementVNode("div", _hoisted_13, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold q-mb-lg" }, " Sobre AMR Advisors ", -1)),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_q_img, {
                  src: require('@/assets/mission.webp')
                }, null, 8, ["src"])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-h6 adicon-font-2 text-bold q-mb-md" }, " Transformamos organizaciones desde adentro, con estrategia, estructura y humanidad. ", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-body adicon-font-1 text-grey-8" }, [
                _createTextVNode(" AMR Advisors es una firma consultora fundada en 2013 por "),
                _createElementVNode("strong", null, "Ana María Reyes"),
                _createTextVNode(", Psicóloga Organizacional con más de 15 años de experiencia en liderazgo estratégico, desarrollo de talento humano y transformación institucional. "),
                _createElementVNode("br"),
                _createElementVNode("br"),
                _createTextVNode(" Acompañamos a empresas públicas y privadas en el diseño e implementación de "),
                _createElementVNode("strong", null, "estructuras organizacionales sólidas"),
                _createTextVNode(", políticas de recursos humanos, procesos de cambio cultural y estrategias para construir "),
                _createElementVNode("strong", null, "entornos laborales más saludables, productivos y sostenibles"),
                _createTextVNode(". "),
                _createElementVNode("br"),
                _createElementVNode("br"),
                _createTextVNode(" Nuestro enfoque integra herramientas técnicas de la psicología organizacional con una mirada práctica, cercana y estratégica. Trabajamos junto a nuestros clientes, no solo como asesores, sino como aliados que se integran temporalmente a su equipo, generando resultados reales y estructuras que permanecen más allá de nuestra intervención. ")
              ], -1))
            ])
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-lg-6 col-md-6 q-pa-xl benefits" }, [
          _createElementVNode("div", {
            style: {"border":"solid 1px #fff","height":"100%"},
            class: "q-pa-lg"
          }, [
            _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col-lg-7" }, [
                _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold q-mb-lg text-white" }, " Nuestra forma de trabajar ")
              ])
            ]),
            _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col-lg-6" }, [
                _createElementVNode("div", { class: "text-h6 adicon-font-1 text-white q-mb-lg" }, [
                  _createElementVNode("i", { class: "fas fa-check text-white on-left" }),
                  _createTextVNode(" Nos involucramos con propósito: entendemos la realidad de cada organización. ")
                ]),
                _createElementVNode("div", { class: "text-h6 adicon-font-1 text-white q-mb-lg" }, [
                  _createElementVNode("i", { class: "fas fa-check text-white on-left" }),
                  _createTextVNode(" Creamos soluciones a medida: nada enlatado, todo adaptado. ")
                ]),
                _createElementVNode("div", { class: "text-h6 adicon-font-1 text-white q-mb-lg" }, [
                  _createElementVNode("i", { class: "fas fa-check text-white on-left" }),
                  _createTextVNode(" Dejamos capacidad instalada: formamos equipos, no dependencia. ")
                ]),
                _createElementVNode("div", { class: "text-h6 adicon-font-1 text-white q-mb-lg" }, [
                  _createElementVNode("i", { class: "fas fa-check text-white on-left" }),
                  _createTextVNode(" Trabajamos con ética y cercanía: las personas siempre están en el centro. ")
                ])
              ])
            ])
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col" }, null, -1)),
              _createElementVNode("div", _hoisted_19, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold q-mb-xl text-white" }, " Nuestra Experiencia ", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("div", {
                  class: "adicon-font-1 text-white q-mb-xl text-justify",
                  style: {"line-height":"35px","font-size":"15px"}
                }, [
                  _createTextVNode(" Nuestra experiencia empieza desde mediados del año 2013, desarrollando servicios de acuerdo a la necesidad de nuestros clientes y del mercado nacional, en diferentes organizaciones y áreas, en estrecha relación directa con nuestros principios. "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createTextVNode(" Hemos ayudado a reestructurar las organizaciones desde la base, con procesos bien definidos, que van desde la cultura organizacional hasta ayudar a certificarlas en estándares de calidad. Nuestro alcance abarca la verificación de resultados óptimos. ")
                ], -1)),
                _withDirectives(_createVNode(_component_q_btn, {
                  outline: "",
                  label: "contáctanos",
                  color: "white",
                  class: "q-px-md q-py-xs q-mb-xl text-bold adicon-font-2",
                  href: "#contacto"
                }, null, 512), [
                  [_directive_smooth_scroll]
                ])
              ])
            ])
          ])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-lg-6 col-md-6 q-py-xl bg-grey-3" }, [
          _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", {
              style: {"width":"40px"},
              class: "desktop-only"
            }),
            _createElementVNode("div", { class: "col-lg-7 q-pa-lg" }, [
              _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold q-mb-xl" }, " Servicios Administrativos "),
              _createElementVNode("div", { class: "text-body2 adicon-font-1 text-grey-7 q-mb-lg" }, " Todo lo dispuesto de nuestra parte como servicios anexos para la mejora continua como valor agregado en el desarrollo de la organización y de su recurso humano. "),
              _createElementVNode("div", { class: "text-h6 adicon-font-2 text-bold q-mb-md" }, [
                _createElementVNode("i", { class: "fas fa-globe text-deep-orange-7 on-left" }),
                _createTextVNode("Traducciones ")
              ]),
              _createElementVNode("div", { class: "text-body2 adicon-font-1 text-grey-7 q-mb-lg" }, " Traducciones de documentos (Italiano - Español, Español - Italiano, Inglés - Español, Español - Inglés, Alemán - Español, Español - Alemán) "),
              _createElementVNode("div", { class: "text-h6 adicon-font-2 text-bold q-mb-md" }, [
                _createElementVNode("i", { class: "far fa-handshake text-deep-orange-7 on-left" }),
                _createTextVNode("Asistencia y organización ")
              ]),
              _createElementVNode("div", { class: "text-body2 adicon-font-1 text-grey-7" }, " Organización y desarrollo de eventos corporativos ")
            ])
          ])
        ], -1))
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col desktop-only" }, null, -1)),
          _createElementVNode("div", _hoisted_22, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold text-center" }, " Nuestros clientes ", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "hidden" }, "Nuestros clientes", -1)),
            _createVNode(_unref(Carousel), _mergeProps(carouselConfig, { style: {"padding":"40px 20px"} }), {
              addons: _withCtx(() => [
                _createVNode(_unref(Navigation)),
                _createVNode(_unref(Pagination))
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(clients, (image, index) => {
                  return _createVNode(_unref(Slide), { key: index }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_img, {
                        src: require(`@/assets/clients/${image}`)
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            }, 16)
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col desktop-only" }, null, -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_23, [
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col desktop-only" }),
          _createElementVNode("div", { class: "col-lg-7 col-xs-12 col-md-12 col-sm-12" }, [
            _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold text-center q-mb-lg" }, " Nuestra dirección "),
            _createElementVNode("h2", { class: "hidden" }, "Nuestra dirección")
          ]),
          _createElementVNode("div", { class: "col desktop-only" })
        ], -1)),
        _createElementVNode("div", _hoisted_24, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col" }, null, -1)),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_q_img, {
              src: require('@/assets/ana-maria.jpg')
            }, null, 8, ["src"])
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col" }, null, -1))
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "row text-justify" }, [
          _createElementVNode("div", { class: "col" }),
          _createElementVNode("div", { class: "col-xs-11 col-sm-11 col-md-9 col-lg-7" }, [
            _createElementVNode("div", { class: "text-subtitle2 text-bold text-center q-mb-xs" }, " Mgtr. Ana María Reyes de Quevedo "),
            _createElementVNode("div", { class: "text-subtitle2 text-bold text-center q-mb-lg" }, [
              _createTextVNode(" Fundadora y Gerente General - AMR Advisors"),
              _createElementVNode("br"),
              _createTextVNode(" Psicóloga Organizacional"),
              _createElementVNode("br"),
              _createTextVNode(" Consultora en Gestión Humana y Desarrollo Organizacional ")
            ]),
            _createElementVNode("div", { class: "text-body" }, [
              _createTextVNode(" Ana María Reyes es Psicóloga Organizacional con más de 15 años de experiencia en el diseño e implementación de estrategias de desarrollo humano, liderazgo y transformación organizacional. Fundadora y Gerente General de "),
              _createElementVNode("strong", null, "AMR Advisors"),
              _createTextVNode(" desde 2013, ha acompañado a empresas públicas y privadas en la creación de estructuras funcionales, procesos de gestión por competencias, estudios de clima, certificaciones ISO y fortalecimiento institucional. "),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createTextVNode(" Ha ocupado posiciones de alta dirección en organizaciones clave, como la "),
              _createElementVNode("strong", null, "Autoridad Marítima de Panamá"),
              _createTextVNode(", donde lideró el área de Recursos Humanos, y "),
              _createElementVNode("strong", null, "Minera Panamá"),
              _createTextVNode(", como Superintendente de Capacitación y Desarrollo. Representó al país como "),
              _createElementVNode("strong", null, "Embajadora de Panamá en Italia"),
              _createTextVNode(" entre 2019 y 2024, liderando la gestión diplomática, administrativa y cultural en la Embajada en Roma. "),
              _createElementVNode("br"),
              _createTextVNode(" Es "),
              _createElementVNode("strong", null, "Licenciada en Psicología Cum Laude por la USMA"),
              _createTextVNode(" y becaria de la Unión Europea para la Maestría en Psicología del Trabajo, las Organizaciones y del Personal (WOP-P), con "),
              _createElementVNode("strong", null, "doble titulación"),
              _createTextVNode(" de la "),
              _createElementVNode("strong", null, "Università di Bologna (Italia)"),
              _createTextVNode(" y la "),
              _createElementVNode("strong", null, "Universidad de Valencia (España)."),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createTextVNode(" Cuenta con certificaciones en: "),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, "Desarrollo del Talento (Global Novations)"),
                _createElementVNode("li", null, " Facilitación DDI (Development Dimensions International, EE.UU.) "),
                _createElementVNode("li", null, "Project Management y Gestión del Capital Humano (ADEN)"),
                _createElementVNode("li", null, "Auditoría Interna ISO 9001 (Delta Q)")
              ]),
              _createElementVNode("br"),
              _createTextVNode(" Ha sido docente universitaria en psicología organizacional y aplicada, y domina el español, inglés e italiano, con formación en francés. "),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createTextVNode(" Su trabajo se basa en la convicción de que las organizaciones sanas y eficientes se construyen desde el respeto por las personas, la claridad en los procesos y una visión estratégica del cambio. ")
            ])
          ]),
          _createElementVNode("div", { class: "col" })
        ], -1))
      ]),
      _createElementVNode("section", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col desktop-only" }, null, -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-12 q-pa-md q-mb-md" }, [
                _createElementVNode("div", { class: "text-h4 adicon-font-2 text-bold text-center" }, " Contáctanos "),
                _createElementVNode("h2", { class: "hidden" }, "Contactanos")
              ], -1)),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_q_input, {
                  square: "",
                  filled: "",
                  label: "Nombre",
                  class: "adicon-font-1",
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  color: "deep-orange-7"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_q_input, {
                  square: "",
                  filled: "",
                  label: "Teléfono",
                  class: "adicon-font-1",
                  mask: "########",
                  modelValue: formData.value.telephone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.telephone) = $event)),
                  color: "deep-orange-7"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_q_input, {
                  square: "",
                  filled: "",
                  label: "Correo electrónico",
                  class: "adicon-font-1",
                  type: "email",
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                  color: "deep-orange-7"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_q_input, {
                  square: "",
                  filled: "",
                  label: "Mensaje",
                  type: "textarea",
                  rows: "7",
                  class: "adicon-font-1",
                  modelValue: formData.value.content,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.content) = $event)),
                  color: "deep-orange-7"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_q_btn, {
                color: "deep-orange-7",
                label: "Enviar",
                class: "adicon-font-2 text-bold q-py-xs q-px-lg",
                style: {"margin":"0 auto"},
                onClick: _cache[4] || (_cache[4] = ($event: any) => (validateContactData()))
              })
            ])
          ]),
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col desktop-only" }, null, -1))
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "row" }, null, -1))
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: contactFormDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((contactFormDialog).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    (contactSuccess.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                      : (_openBlock(), _createElementBlock("i", _hoisted_36))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                default: _withCtx(() => [
                  (!contactSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, " Porfavor verifica todos los campos. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[32] || (_cache[32] = [
                        _createTextVNode(" Su mensaje ha sido enviado con exito. "),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("Pronto nos pondremos en contacto con usted. ")
                      ])))
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { align: "right" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    flat: "",
                    label: "Aceptar",
                    color: "deep-orange-7"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_39, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "col desktop-only" }, null, -1)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_q_img, {
                    src: require('@/assets/logo.svg')
                  }, null, 8, ["src"])
                ]),
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-body2 text-white adicon-font-2 text-bold q-mb-sm" }, " AMR Advisors ", -1)),
                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-body2 text-white adicon-font-1 q-mb-md" }, " Apoyamos a Recursos Humanos en todas las etapas de desarrollo, desde la definición de procesos hasta el reclutamiento y formación de equipos efectivos. ", -1))
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col" }, null, -1)),
              _createElementVNode("div", _hoisted_44, [
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "text-body2 text-white adicon-font-2 text-bold q-mb-sm" }, " Enlaces ", -1)),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_45, _cache[35] || (_cache[35] = [
                  _createTextVNode("Inicio")
                ]))), [
                  [_directive_smooth_scroll]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_46, _cache[36] || (_cache[36] = [
                  _createTextVNode("Servicios")
                ]))), [
                  [_directive_smooth_scroll]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_47, _cache[37] || (_cache[37] = [
                  _createTextVNode("Nosotros")
                ]))), [
                  [_directive_smooth_scroll]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_48, _cache[38] || (_cache[38] = [
                  _createTextVNode("Nuestros clientes")
                ]))), [
                  [_directive_smooth_scroll]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_49, _cache[39] || (_cache[39] = [
                  _createTextVNode("Nuestra dirección")
                ]))), [
                  [_directive_smooth_scroll]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_50, _cache[40] || (_cache[40] = [
                  _createTextVNode("Contacto")
                ]))), [
                  [_directive_smooth_scroll]
                ])
              ]),
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "col-lg-2 col-md-2 col-xs-6" }, [
                _createElementVNode("div", { class: "text-body2 text-white adicon-font-2 text-bold q-mb-sm" }, " Siguenos "),
                _createElementVNode("a", {
                  href: "https://www.facebook.com/AMRAdvisors/",
                  target: "_blank",
                  class: "adicon-font-1 text-white q-mb-sm",
                  style: {"text-decoration":"none","display":"block"}
                }, [
                  _createElementVNode("i", { class: "fab fa-facebook" }),
                  _createTextVNode(" AMRAdvisors")
                ]),
                _createElementVNode("a", {
                  href: "https://www.linkedin.com/company/amr-advisors/",
                  target: "_blank",
                  class: "adicon-font-1 text-white q-mb-sm",
                  style: {"text-decoration":"none","display":"block"}
                }, [
                  _createElementVNode("i", { class: "fab fa-linkedin" }),
                  _createTextVNode(" AMR Advisors")
                ]),
                _createElementVNode("a", {
                  href: "https://twitter.com/AMRAdvisors",
                  target: "_blank",
                  class: "adicon-font-1 text-white q-mb-sm",
                  style: {"text-decoration":"none","display":"block"}
                }, [
                  _createElementVNode("i", { class: "fab fa-twitter" }),
                  _createTextVNode(" AMRAdvisors")
                ]),
                _createElementVNode("a", {
                  href: "https://www.instagram.com/amradvisors",
                  target: "_blank",
                  class: "adicon-font-1 text-white q-mb-sm",
                  style: {"text-decoration":"none","display":"block"}
                }, [
                  _createElementVNode("i", { class: "fab fa-instagram" }),
                  _createTextVNode(" amradvisors")
                ])
              ], -1)),
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "col-lg-3" }, [
                _createElementVNode("div", { class: "text-body2 text-white adicon-font-2 text-bold q-mb-sm" }, " Contactanos "),
                _createElementVNode("a", {
                  href: "mailto:vacantes@amradvisors.com.pa",
                  target: "_blank",
                  class: "adicon-font-1 text-white q-mb-sm",
                  style: {"text-decoration":"none","display":"block"}
                }, [
                  _createElementVNode("i", { class: "far fa-envelope" }),
                  _createTextVNode(" vacantes@amradvisors.com.pa")
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_q_separator, {
                color: "secondary",
                class: "q-mb-lg"
              }),
              _createElementVNode("div", _hoisted_52, [
                _createTextVNode(" Copyright © " + _toDisplayString(new Date().getFullYear()) + " Todos los derechos reservados. Desarrollado por ", 1),
                _cache[45] || (_cache[45] = _createElementVNode("a", {
                  href: "https://blueballoon.io",
                  target: "_blank",
                  class: "text-white"
                }, "BlueBalloon Inc.", -1))
              ])
            ])
          ]),
          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col desktop-only" }, null, -1))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})